export default __webpack_public_path__ + "7d8a523acf17ff37a5d2e83352c5a4db.png";